import FlightIcon from '@mui/icons-material/Flight';
import React, { PropsWithChildren, useCallback, useEffect } from 'react';

import Image from '~/components/Image/Image';

import styles from './HeaderSummarySection.module.scss';

interface HeaderSummarySectionComponentProps extends PropsWithChildren<any> {
  title: string;
  subTitle?: string;
  logo?: string;
}

export const HeaderSummarySectionComponent: React.FC<HeaderSummarySectionComponentProps> = ({
  title,
  subTitle,
  children,
  logo,
}) => {
  const defaultLogo = <FlightIcon fontSize="large" className={styles.icon} style={{ color: '#fff' }} />;
  useEffect(() => {}, []);

  const handleGetLogo = useCallback((image?: string) => {
    switch (image) {
      case undefined:
        return defaultLogo;
      case null:
        return defaultLogo;
      case '':
        return defaultLogo;

      default:
        return image;
    }
  }, []);

  return (
    <div className={styles.header}>
      <div className="d-flex align-items-center justify-content-center">
        <div className={styles.icon_area}>
          {typeof handleGetLogo(logo) === 'string' ? (
            <Image image={'https://demo-api-paygw.dbsafricapay.com:8443' + (handleGetLogo(logo) as string)} />
          ) : (
            handleGetLogo(logo)
          )}
        </div>
        <div className="d-flex flex-col">
          <div className={styles.title}>{title}</div>
          <div>{subTitle}</div>
        </div>
      </div>
      <div className="flex-1">{children}</div>
    </div>
  );
};
